import { lazy } from 'react'

const IconArrow = lazy(async () =>
    import('./icon-arrow').then((module) => ({ default: module.IconArrow })),
)
const IconCar = lazy(async () =>
    import('./icon-car').then((module) => ({ default: module.IconCar })),
)
const IconCard = lazy(async () =>
    import('./icon-card').then((module) => ({ default: module.IconCard })),
)
const IconCheckFilled = lazy(async () =>
    import('./icon-check-filled').then((module) => ({ default: module.IconCheckFilled })),
)
const IconCheck = lazy(async () =>
    import('./icon-check').then((module) => ({ default: module.IconCheck })),
)
const IconChevron = lazy(async () =>
    import('./icon-chevron').then((module) => ({ default: module.IconChevron })),
)
const IconEdit = lazy(async () =>
    import('./icon-edit').then((module) => ({ default: module.IconEdit })),
)
const IconMoney = lazy(async () =>
    import('./icon-money').then((module) => ({ default: module.IconMoney })),
)
const IconSberPay = lazy(async () =>
    import('./icon-sber-pay').then((module) => ({ default: module.IconSberPay })),
)
const IconSbp = lazy(async () =>
    import('./icon-sbp').then((module) => ({ default: module.IconSbp })),
)
const IconStarSmall = lazy(async () =>
    import('./icon-star-small').then((module) => ({ default: module.IconStarSmall })),
)
const IconStar = lazy(async () =>
    import('./icon-star').then((module) => ({ default: module.IconStar })),
)
const IconWalletOne = lazy(async () =>
    import('./icon-wallet-one').then((module) => ({ default: module.IconWalletOne })),
)
const IconWarningFill = lazy(async () =>
    import('./icon-warning-fill').then((module) => ({ default: module.IconWarningFill })),
)
const IconWarning = lazy(async () =>
    import('./icon-warning').then((module) => ({ default: module.IconWarning })),
)
const IconX = lazy(async () => import('./icon-x').then((module) => ({ default: module.IconX })))
const IconXFill = lazy(async () =>
    import('./icon-x-fill').then((module) => ({ default: module.IconXFill })),
)

export const IconsTypes = {
    arrow: IconArrow,
    card: IconCard,
    car: IconCar,
    checkFilled: IconCheckFilled,
    check: IconCheck,
    chevron: IconChevron,
    edit: IconEdit,
    money: IconMoney,
    sberPay: IconSberPay,
    sbp: IconSbp,
    starSmall: IconStarSmall,
    star: IconStar,
    walletOne: IconWalletOne,
    warningFill: IconWarningFill,
    warning: IconWarning,
    x: IconX,
    xFill: IconXFill,
}

export interface IIconProps {
    color?: string
    icon: keyof typeof IconsTypes
    onClick?: (event: React.MouseEvent<SVGSVGElement>) => void
    padding?: number
    rotate?: number
    size: number
}

export type TIconSvgProps = Omit<IIconProps, 'icon'>
